const { host, origin, hostname } = window.location

export { host, origin, hostname }
